var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZluri(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 34,
    viewBox: "0 0 68 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_48_1101)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.555,
    cy: 6.44488,
    r: 6.44488,
    fill: "#57E1FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5554,
    cy: 6.44488,
    r: 5.45336,
    fill: "#D3FF57"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5552,
    cy: 6.44481,
    r: 4.13133,
    fill: "#FF4B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1865 25.753V10.793H46.0891V17.2974L46.0349 15.3143C46.0349 13.2185 46.7917 12.5811 47.3094 12.0635C48.3009 11.0719 49.4859 10.5762 51.13 10.5762H51.7263V14.804H50.588C49.4859 14.804 48.6277 15.1021 48.0134 15.6984C47.4171 16.2946 47.119 17.1528 47.119 18.273V25.753H42.1865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3309 25.8922C29.6326 25.8922 28.3136 25.3411 27.3741 24.239C26.4527 23.1188 25.9919 21.7419 25.9919 19.4473V10.7748H30.9244V19.5828C30.9244 20.2513 31.1232 20.7933 31.5207 21.2089C31.9181 21.6244 32.4511 21.8322 33.1196 21.8322C33.7882 21.8322 34.3302 21.6244 34.7457 21.2089C35.1613 20.7933 35.3691 20.2332 35.3691 19.5286V10.7748H40.3016V25.7348H36.3989V24.28C35.8129 24.874 35.4512 25.0713 34.5851 25.4823C33.5936 25.9529 32.668 25.8922 31.5478 25.8922H31.3309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5868 25.7795V10.8195H60.5193V25.7795H55.5868ZM53.6897 14.3969V10.8195H60.5193V14.3969H53.6897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5552,
    cy: 6.44499,
    r: 2.80931,
    fill: "#2D2828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 25.7797V22.7172L10.6399 14.7222V15.1559L9.93524 14.2886L10.4773 14.5596H4.0542V10.8196H16.1957V13.8821L9.55582 21.8771V21.4434L10.2605 22.3107L9.71843 22.0397H16.3583V25.7797H4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.902 25.7797V5.99554H23.8345V25.7797H18.902ZM17.2217 9.57295V5.99554H23.8345V9.57295H17.2217Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_48_1101",
    x: 0,
    y: 0,
    width: 67.9998,
    height: 33.8947,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_48_1101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_48_1101",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZluri);
export default __webpack_public_path__ + "static/media/zluri.a2bfe70e333aa1ce0ba2afbccf607bee.svg";
export { ForwardRef as ReactComponent };